export const mockCategories = [
  { id: 'bureau', name: 'مستلزمات المكتب', nameEn: 'Office Supplies' },
  { id: 'ecriture', name: 'أدوات الكتابة', nameEn: 'Writing Tools' },
  { id: 'papier', name: 'ورق ودفاتر', nameEn: 'Paper & Notebooks' },
  { id: 'rangement', name: 'تنظيم وتخزين', nameEn: 'Storage & Organization' },
  { id: 'informatique', name: 'ملحقات رقمية', nameEn: 'Digital Accessories' }
];

export const mockProducts = [
  {
    id: 'prod-1',
    name: 'دفتر ملاحظات فاخر',
    category: 'ورق ودفاتر',
    price: 450,
    originalPrice: 550,
    stock: 24,
    description: 'دفتر أنيق مناسب للدراسة والعمل اليومي بغلاف متين وأوراق عالية الجودة.',
    image: 'https://images.unsplash.com/photo-1531346680769-a1d79b57de5c?auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1531346680769-a1d79b57de5c?auto=format&fit=crop&w=800&q=80'
    ],
    rating: 4.7,
    reviews: 18
  },
  {
    id: 'prod-2',
    name: 'مجموعة أقلام جل',
    category: 'أدوات الكتابة',
    price: 320,
    originalPrice: 390,
    stock: 40,
    description: 'مجموعة أقلام جل بألوان متعددة وسلاسة كتابة ممتازة.',
    image: 'https://images.unsplash.com/photo-1583485088034-697b5bc54ccd?auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1583485088034-697b5bc54ccd?auto=format&fit=crop&w=800&q=80'
    ],
    rating: 4.5,
    reviews: 27
  },
  {
    id: 'prod-3',
    name: 'منظم مكتب خشبي',
    category: 'تنظيم وتخزين',
    price: 1800,
    originalPrice: 2200,
    stock: 9,
    description: 'منظم مكتب أنيق يساعد على ترتيب الأدوات والملفات بطريقة عملية.',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=80'
    ],
    rating: 4.8,
    reviews: 11
  },
  {
    id: 'prod-4',
    name: 'طابعة ملصقات صغيرة',
    category: 'ملحقات رقمية',
    price: 5200,
    stock: 6,
    description: 'طابعة ملصقات محمولة وسهلة الاستخدام لتنظيم الملفات والأغراض.',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=800&q=80'
    ],
    rating: 4.4,
    reviews: 8
  },
  {
    id: 'prod-5',
    name: 'حافظة ملفات A4',
    category: 'مستلزمات المكتب',
    price: 260,
    stock: 35,
    description: 'حافظة عملية لحفظ المستندات والوثائق بحجم A4.',
    image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=800&q=80'
    ],
    rating: 4.2,
    reviews: 14
  },
  {
    id: 'prod-6',
    name: 'رزمة ورق طباعة',
    category: 'ورق ودفاتر',
    price: 950,
    stock: 50,
    description: 'ورق طباعة أبيض عالي الجودة مناسب للمكاتب والمدارس.',
    image: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=800&q=80'
    ],
    rating: 4.6,
    reviews: 21
  }
];

export const mockSettings = {
  storeName: 'Fournitures',
  banner: 'أفضل مستلزمات المكتب والدراسة',
  bannerText: 'اكتشف منتجات عملية وعصرية مع توصيل سريع إلى جميع الولايات',
  bannerImage: '',
  facebookPixelId: '',
  tiktokPixelId: '',
  tiktokPixelSnippet: '',
  socialLinks: {
    facebook: '',
    instagram: '',
    tiktok: '',
    whatsapp: '213000000000',
    phone: '0550 00 00 00',
    email: 'contact@fournitures.dz'
  }
};

export const mockOrders = [
  {
    id: 'order-1',
    trackingCode: 'FRN-1001',
    name: 'محمد أمين',
    phone: '0550000001',
    wilaya: 'الجزائر',
    commune: 'باب الزوار',
    total: 2750,
    status: 'pending',
    createdAt: new Date().toISOString(),
    products: [
      { id: 'prod-1', name: 'دفتر ملاحظات فاخر', price: 450, quantity: 1 },
      { id: 'prod-3', name: 'منظم مكتب خشبي', price: 1800, quantity: 1 }
    ]
  }
];
